import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Toast} from 'primereact/toast';
import axios from '../../../axios-url';
import {Dialog} from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG, DATATABLE_CONFIG, APPROVAL_TYPE_SUBMENU_ID} from '../../../shared/Config';
import { HASACCESS } from '../../../shared/utility';    
import * as actions from '../../../store/actions/index';
class ApprovalType extends Component {
    state = {

        selectedData : [],
        approvalTypeData : [],
        loading : false,     
        display : false,
        approvalName : '',
        approvalType : null,
        positionName: null,
        employeeName : null,
        roleName: null,
        approvalTypes : [
            { label: 'Position', value: 1 },
            { label: 'Employee', value: 2 },
            { label: 'ApprovalRole', value: 3 }
        ],
        Id : null,
        type : 'Add'      
    }


    deleteApprovalType = () => {

        if(this.state.selectedData.length > 0){
            this.setState({loading : true});
            const updatedValue = this.state.selectedData.map( value => {
                return value.id;
            });    
            const filteredValue = this.state.approvalTypeData.filter(item => {    
                return updatedValue.includes(item.id) === false;
             
            });

            axios.post('/master/api/DeleteApprovalType',JSON.stringify(this.state.selectedData))
            .then(response =>{
                if(response.status === 200){
                    this.growl.show({severity: 'success', summary: null, detail: 'Deleted Successfully.'});
                    this.setState({approvalTypeData:filteredValue});
                    //localStorage.setItem('approvalTypeData',JSON.stringify(filteredValue));
                }else{
                    this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong'});
                }
                this.setState({loading : false});
            })
            .catch(err => {
                this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong'});
                this.setState({loading : false});
            })  
            this.setState({selectedData:[]})
        }else{
            this.growl.show({severity: 'error', summary: null, detail: 'Please select atleast one checkbox'});
        }


    }


    editItem = (value,type) => {

        this.setState({display : true,approvalName: value.approvalTypeName, approvalType:value.approvalTypeID,
            positionName:value.positionID,employeeName:value.employeeID,roleName:value.roleid,Id: value.id, type: type});
    }


  

    actionTemplate = (rowData) => {
        return <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                <Button type="button" icon="pi pi-pencil" onClick={() => this.editItem(rowData,'Edit')}  className="p-button-info"></Button>
            }
            {(this.getAccess!==undefined && this.getAccess.viewAccess!== false) &&
                <Button type="button" icon="pi pi-eye" onClick={() => this.editItem(rowData,'View')}  className="p-button-secondary"></Button>
            }
          </div>;
    }


    componentDidMount(){
        this.getApprovalList();
        this.props.getMasterKeywordList('Employee');
        this.props.getMasterKeywordList('Position');
        this.props.getMasterKeywordList('ApprovalRole');
        this.getAccess = HASACCESS(APPROVAL_TYPE_SUBMENU_ID);
    }
 

    //fetch Approval Type List
    getApprovalList = () => {

        // const approvalStorageData = localStorage.getItem('approvalTypeData');
        // if(!approvalStorageData){
            this.setState({loading : true});
            axios.get('/master/api/GetApprovalType')
            .then(response =>{
                if(response.status === 200){
                    this.setState({approvalTypeData:response.data});
                    //localStorage.setItem('approvalTypeData',JSON.stringify(response.data));
                }
                this.setState({loading : false});
            })
            .catch(err => {
                this.setState({loading : false});
            })    
        // }else{
        //     this.setState({approvalTypeData:JSON.parse(approvalStorageData)});
        // }
    }


  

    export = () => {
        this.dt.exportCSV();
    }

    clear = () => {
        this.setState({display:false,approvalName:'',approvalType:null,positionName:null,employeeName:null,roleName:null,type: "Add"})
    }


    updateDetail = (e) => {


        const { name, value } = e.target;

        this.setState({[name]: value});

        
    }



    addApprovalTypeFunc = () => {
        this.setState({loading : true});

        let data = {
            ApprovalName: this.state.approvalName,
            ApprolvaType: this.state.approvalType,
            PositionID: (this.state.approvalType === 1 ) ? this.state.positionName : (this.state.approvalType === 3 ) ? '99999997-9999-9999-9999-999999999999' : null,
            EmployeeID: (this.state.approvalType === 2 ) ? this.state.employeeName : null,
            Roleid: (this.state.approvalType === 3 ) ? this.state.roleName : null, 
            IsActive: true,
            ID: this.state.Id,
            CreatedBy: (this.props.loggedUserDetail.userName) ?? 'Admin',
            CreatedDate: new Date()
        };
       
     

        let url = (this.state.type === 'Edit') ? '/master/api/UpdateApprovalType' : '/master/api/AddApprovalType'

        let message = (this.state.type === 'Edit') ? 'Approval type updated successufully' : 'Approval type added successufully'

        axios.post(url,JSON.stringify(data))
            .then(response =>{
                if(response.data.statusCode === 1){
                    //localStorage.removeItem('approvalTypeData');
                    this.growl.show({severity: 'success', summary: null, detail: message});
                    this.clear();
                    this.getApprovalList();
                   
                }else{
                    this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong'});
                }
                this.setState({loading : false});
            })
            .catch(err => {
                this.growl.show({severity: 'error', summary: null, detail: 'Something went wrong'});
                this.setState({loading : false});
            })   

    }
    

 
    
  
    render() {   
        if(this.getAccess!==undefined && this.getAccess.viewAccess === false){
            this.props.history.push('/dashboard');
        }
       

        let isEnabled = false;

        if(this.state.approvalName !== '' && (this.state.approvalType !== null || this.state.approvalType !== null) && (this.state.positionName!==null || this.state.employeeName!==null|| this.state.roleName!==null)){
            isEnabled = true;
        }

       

        let nameSele = 'Update';
        let nameTitle = 'Update';
        if(this.state.type=== 'Add'){
            nameTitle = 'Add';
            nameSele = 'Save';
        }else if(this.state.type=== 'View'){
            nameTitle = 'View';
        }

        const dialogFooter = (
            <div>

                {   ((this.state.type === 'Add' && this.getAccess!==undefined && this.getAccess.addAccess!== false) || 
                    (this.state.type === 'Edit' && this.getAccess!==undefined && this.getAccess.editAccess!== false)) &&
                    <Button disabled={!isEnabled} className="p-button-primary"  icon="pi pi-check" onClick={this.addApprovalTypeFunc} label={nameSele} />
                }
                <Button icon="pi pi-times" onClick={this.clear} label="Cancel" className="p-button-secondary" />
            </div>
        )


        return (
            <div className="p-grid approvalType padding ">
                { this.state.loading && <div className="page-loader"></div>}
                <Toast ref={(el) => this.growl = el} />
               <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>Approval Type</h1>
               
                        <div className="p-grid">
                         

                            <div className="p-col-12 p-lg-12">
                                <div className="mt1">
                                {(this.getAccess!==undefined && this.getAccess.addAccess!== false) && 
                                <Button style={{float: 'right'}} label="Add" icon="pi pi-plus" className="ml1" onClick={()=>this.setState({display:true})} />
                                }
                                {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                                <Button onClick={this.deleteApprovalType} style={{float: 'right'}} label="Delete" icon="pi pi-trash"  className="p-button-danger ml1"/>
                                }

                                <Button onClick={this.export} style={{float: 'right'}} label="Export" icon="pi pi-download"  className="p-button-secondary"/>
                                </div>                                
                            </div>
                      
                            					 	
                        <div className="p-col-12" style={{marginTop:'2em'}}>
                            <DataTable selection={this.state.selectedData}  onSelectionChange={e => this.setState({selectedData: e.value})} value={this.state.approvalTypeData} ref={(el) => { this.dt = el; }} {...DATATABLE_CONFIG}>
                                <Column selectionMode="multiple" style={{ width: '3em' }} />
                                <Column field="approvalTypeName" filterPlaceholder="Search Approval Type" filter={true} sortable={true} header="Approval Type Name" />
                                <Column field="positionName" filter={true} filterPlaceholder="Search Position"  header="Position" />
                                <Column field="employeeName" filter={true} filterPlaceholder="Search Employee" header="Employee" />
                                <Column field="roleName" filter={true} filterPlaceholder="Search Role" header="Role" />
                                <Column body={this.actionTemplate} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                            </DataTable>
                        </div>
                        

                        <Dialog header={nameTitle + " Approval Type"} visible={this.state.display} modal={true}  style={{width: '50vw'}} footer={dialogFooter} onHide={this.clear} blockScroll >


                        <h5 style={{marginTop:'1px'}}>Approval Name</h5>
                        <span className="p-float-label">
                            <InputText type="text" className="p-col-12" value={this.state.approvalName} name="approvalName" onChange={(e) => this.updateDetail(e)} />
                          
                        </span>

                        <h5>Approval Type</h5>
                        <span className="p-float-label">
                            <Dropdown className="p-col-12"  options={this.state.approvalTypes} name="approvalType" value={this.state.approvalType}  onChange={(e) => this.updateDetail(e)}  placeholder="Select Approval Type" {...DROPDOWN_CONFIG} />
                        </span>
                        

                        {this.state.approvalType === 1 && 
                        <>
                        <h5>Position</h5>
                        <span className="p-float-label">
                            <Dropdown placeholder="Select Position" value={this.state.positionName} name="positionName" options={this.props.Position} onChange={(e) => this.updateDetail(e)} style={{ width: '100%' }}  className="p-col-12"  {...DROPDOWN_CONFIG}  />
                            
                        </span>
                        </>
                        }
                        {this.state.approvalType === 2 &&
                        <>
                        <h5>Employee</h5>
                        <span className="p-float-label">
                        <Dropdown placeholder="Select Employee" name="employeeName" value={this.state.employeeName} options={this.props.GetEmployeedropdown} onChange={(e) => this.updateDetail(e)} style={{ width: '100%' }} {...DROPDOWN_CONFIG} className="p-col-12" />  
                            
                        </span>
                        </>
                        }
                        {this.state.approvalType === 3 &&
                        <>
                        <h5>Role</h5>
                        <span className="p-float-label">
                        <Dropdown placeholder="Select Role" name="roleName" value={this.state.roleName} options={this.props.GetRoledropdown} onChange={(e) => this.updateDetail(e)} style={{ width: '100%' }} {...DROPDOWN_CONFIG} className="p-col-12" />  
                            
                        </span>
                        </>
                        }                        
                        <br/>
                        </Dialog>


                        </div>

                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        GetEmployeedropdown : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        Position : (state.keyword.Position!==undefined) ? state.keyword.Position : [],
        GetRoledropdown : (state.keyword.ApprovalRole!==undefined) ? state.keyword.ApprovalRole : [],
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(ApprovalType);
